import apiClient, { extractApiPayloadMessage, getApiErrorMessage } from './apiClient';

const assertAdminSuccess = (payload, fallbackMessage) => {
  if (payload && typeof payload === 'object' && payload.success === false) {
    throw new Error(extractApiPayloadMessage(payload) || fallbackMessage);
  }
};

const normalizeEntities = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const entityPath = (projectId, entity) =>
  `/projects/${encodeURIComponent(projectId)}/entities/${encodeURIComponent(entity)}`;

export const fetchProjectEntitiesApi = async (projectId) => {
  try {
    const { data } = await apiClient.get(`/projects/${encodeURIComponent(projectId)}/entities`);
    assertAdminSuccess(data, 'Failed to load project entities.');
    return normalizeEntities(data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load project entities.'));
  }
};

export const fetchProjectEntityApi = async ({ projectId, entity }) => {
  try {
    const { data } = await apiClient.get(entityPath(projectId, entity));
    assertAdminSuccess(data, 'Failed to load entity.');
    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load entity.'));
  }
};

export const createProjectEntityApi = async ({
  projectId,
  name,
  displayName,
  authNeed,
  isPrivate,
  fields
}) => {
  try {
    const { data } = await apiClient.post(`/projects/${encodeURIComponent(projectId)}/entities`, {
      name,
      displayName,
      authNeed,
      isPrivate,
      fields
    });
    assertAdminSuccess(data, 'Failed to create entity.');
    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create entity.'));
  }
};

export const updateProjectEntityApi = async ({ projectId, entity, displayName, authNeed, isPrivate }) => {
  try {
    const { data } = await apiClient.patch(entityPath(projectId, entity), {
      displayName,
      authNeed,
      isPrivate
    });
    assertAdminSuccess(data, 'Failed to update entity.');
    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update entity.'));
  }
};

export const replaceEntityFieldsApi = async ({ projectId, entity, fields }) => {
  try {
    const { data } = await apiClient.put(`${entityPath(projectId, entity)}/fields`, { fields });
    assertAdminSuccess(data, 'Failed to save entity fields.');
    return data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to save entity fields.'));
  }
};
